import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07f4e29b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "display-items"
}

import { computed, ref } from 'vue'
import { MultiSelect } from '@progress/kendo-vue-dropdowns';
import { filterBy } from '@progress/kendo-data-query';
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'IBMultiSelectCaseReport',
  props: {
  options: {
    type: Array<any>,
    required: true
  },
  prefill: {
    type: [Array<string>, String],
  },
  required: {
    type: Boolean,
    default: false,
  }
},
  setup(__props) {

const props = __props;



const reactiveOptions = ref(props.options.slice())

const onFilterChange = (event: any) => {
  reactiveOptions.value = filterBy(props.options.slice(), event.filter)
}

const defaultValue = computed( (): Array<any> => {
  if (Array.isArray(props.prefill)) {
    return props.prefill
  } else if (props.prefill) {
    return new Array(props.prefill)
  }
  return []
})

const { t } = useI18n({
  inheritLocale: true,
  useScope: "local",
});


return (_ctx: any,_cache: any) => {
  return (!_ctx.$attrs.disabled)
    ? (_openBlock(), _createBlock(_unref(MultiSelect), _mergeProps({
        key: 0,
        onFilterchange: onFilterChange,
        filterable: true
      }, _ctx.$attrs, {
        "data-items": reactiveOptions.value,
        defaultValue: _unref(defaultValue),
        style: {width: '100%'},
        autoClose: false,
        onKeydown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        popupSettings: {
        className: 'ib-drop-downs',
        height: '600px'
      },
        required: __props.required,
        placeholder: _unref(t)('component.multiselect.placeholder')
      }), null, 16, ["data-items", "defaultValue", "required", "placeholder"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$attrs.modelValue, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            class: "item"
          }, _toDisplayString(item), 1))
        }), 128))
      ]))
}
}

})